import { PaginationBar } from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  pageChangeCallback,
  pageSizeChangeCallback
} from 'Pages/SourcesList/recoil/callbacks/callbacks'
import { pageState } from 'Pages/SourcesList/recoil/state/page'

const Pagination = () => {
  const intl = useIntl()

  const { pageNumber, pageSize, totalItems } = useRecoilValue(pageState)

  const handleChangePage = useRecoilCallback(pageChangeCallback)
  const handleChangePageSize = useRecoilCallback(pageSizeChangeCallback)

  return (
    <PaginationBar
      pageNumber={pageNumber}
      pageSize={pageSize}
      totalItems={totalItems}
      handleChangePage={handleChangePage}
      handleChangePageSize={handleChangePageSize}
      data-mu-test='pager'
      strings={{
        of: intl.formatMessage({ id: 'Load.Pager.Of' }),
        label: intl.formatMessage({ id: 'Load.Pager.Items' })
      }}
    />
  )
}

export default Pagination
